import { Component, OnInit, Input } from '@angular/core';
import { ValidationErrors, FormControl, FormGroup, AbstractControl } from '@angular/forms';
import { HelperService } from 'src/app/services/utils/helper.service';

/**
 * Error component
 */
@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit {
  /**
   * control
   */
  @Input() control: AbstractControl;

  /**
   * indicate if submit is clicked
   */
  @Input() isSubmit: boolean;

  /**
   * caption for the control
   */
  @Input() caption: string;

  /**
   * constructor to inject dependency
   * @param helperService instance of helperService
   */
  constructor(private helperService: HelperService) {}

  /**
   * initialize component
   */
  ngOnInit() {}

  /**
   * check if control is invalid
   */
  isControlInvalid() {
    
    return this.helperService.isControlInvalid(this.isSubmit, this.control);
  }
}
